"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractStore = void 0;
class ContractStore {
    static getRailgunSmartWalletContract(chain) {
        try {
            return this.railgunSmartWalletContracts[chain.type][chain.id];
        }
        catch {
            throw new Error('No RailgunSmartWalletContract loaded.');
        }
    }
    static getRelayAdaptContract(chain) {
        try {
            return this.relayAdaptContracts[chain.type][chain.id];
        }
        catch {
            throw new Error('No RelayAdaptContract loaded.');
        }
    }
}
ContractStore.railgunSmartWalletContracts = [];
ContractStore.relayAdaptContracts = [];
exports.ContractStore = ContractStore;
